// extracted by mini-css-extract-plugin
export default {"cardWrapper":"DrawWinnersPage_cardWrapper__qfbWM","noTasks":"DrawWinnersPage_noTasks__podkU"};